import { ref } from '@vue/composition-api';

export default function () {
  const username = ref('');
  const gamertag = ref('');
  const email = ref('');
  const password = ref('');
  const passwordConfirm = ref('');
  const loading = ref(false);
  const errorMessage = ref('');
  const usernameError = ref('');

  return {
    username,
    gamertag,
    password,
    email,
    passwordConfirm,
    loading,
    errorMessage,
    usernameError,
  };
}
